import { useEffect } from "react";
import { motion } from "framer-motion";
import HeroSection from "../ProgramsCompo/Herosection";
import Navbar from "../Navbar";
import { Marquee } from "../ui/Marquee";
import { useTranslation } from "react-i18next";
import { landingMotionInView } from "@/utils/landingMotion";
import Aboutus from "../ProgramsCompo/Aboutus";
import HowItWorks from "../ProgramsCompo/HowItWorks";
import FaqSection from "../landing/FaqSection";
import Footer from "../Footer";
import CommunityCard from "../landing/CommunityCard";
import TestimonialSection from "../landing/TestimonialSection";
import VoiceSection from "../landing/VoiceSection";
import VideoSection from "../landing/VideoSection";
import FeaturedIn from "../landing/FeaturedIn";
import PartnershipFunnelSection from "../ProgramsCompo/PartnershipSection";
import ChooseCard from "../ProgramsCompo/ChooseCard";
import Features from "../ProgramsCompo/Features";
import PricingComparisionTable from "../Pricing/PricingComparisionTable";
import { seoData, updateMetaTags } from "@/utils/seo";

function FeatureBadge({ label }: { label: string }) {
  return (
    <div className="w-fit h-auto p-[1px] rounded-[20px] bg-gradient-to-l from-[#1CCDE6] to-[#DBD633] flex justify-center items-center">
      <div className="w-fit px-5 py-2 bg-black text-white rounded-[20px] gap-x-2 flex items-center justify-center">
        <div className="p-[1px] rounded-full bg-gradient-to-r from-[#1CCDE6] to-[#DBD633]">
          <div className="flex h-4 w-4 items-center justify-center rounded-full bg-black">
            <span className="text-[10px] bg-gradient-to-r from-[#1CCDE6] to-[#DBD633] bg-clip-text text-transparent">
              &#10003;
            </span>
          </div>
        </div>
        <span className="text-base font-nexa">{label}</span>
      </div>
    </div>
  );
}



export default function SalesPage() {
  useEffect(() => {
    updateMetaTags(seoData.programs, "/programs");
  }, []);

  const { t } = useTranslation();

  const topBadges = [
    "Daily Payouts Available",
    t("No SL Required"),
    "Backed By A Broker",
    t("Unlimited Days"),
    t("EAs Allowed"),
  ];


  return (
    <div className="flex flex-col overflow-hidden bg-black">
      <Navbar />
      <div className="relative">
        <img src="/image/herosection/ellipse.png" alt="ellipse" className="absolute h-[1000px] w-[500px] top-0 z-0 left-0 object-cover" />
        <HeroSection />
      </div>
      {/* MARQUEE */}
      <motion.div
        className="pt-5 pb-16 overflow-hidden"
        {...landingMotionInView}
      >
        <Marquee pauseOnHover className="[--duration:25s] ![--gap:1rem] bg-transparent py-1">
          {topBadges.map((badge, index) => (
            <FeatureBadge key={`${badge}-${index}`} label={badge} />
          ))}
        </Marquee>
      </motion.div>

      <Aboutus subtitle={true} />
      <HowItWorks />
      <ChooseCard />
      <Features />



      <PartnershipFunnelSection />
      <motion.div
        className="pt-10 "
        {...landingMotionInView}
      >
        <motion.div
          className="relative h-full w-full py-10 flex justify-end items-center max-w-[1140px] mx-auto"
          {...landingMotionInView}
        >
          <FeaturedIn />
        </motion.div>
      </motion.div>


      <div className="relative">
        <img src="/image/herosection/ellipse.png" alt="ellipse" className="absolute h-[1000px] w-[500px] top-0 z-20 left-0 object-cover" />
      <VideoSection />
      </div>

      
      <div className="bg-[url('assets/landingpage/videosection/globellipse.png')] bg-no-repeat bg-contain bg-left">
        <VoiceSection />
      </div>



      <TestimonialSection />



      <div className="relative z-10  pt-8 md:pt-12 xl:px-0 px-4  bg-cover bg-left-top bg-no-repeat">

        {/* hero information */}
        {/* subtitle The lading prop firm */}
        <div className="flex flex-col items-center justify-center mx-auto max-w-7xl px-4 xl:px-0">
          <motion.div
            className="w-fit h-auto p-[1.5px] rounded-[20px] bg-gradient-to-l from-[#1CCDE6] to-[#DBD633] flex justify-center items-center"
            {...landingMotionInView}
          >
            <div className="w-full px-3 bg-black/80 backdrop-blur-sm text-dark rounded-[20px] py-1 flex items-center justify-center">
              <span
                className="bg-clip-text font-creato text-sm md:text-base uppercase text-transparent font-bold"
                style={{
                  backgroundImage:
                    "linear-gradient(to left, #D7D536, #20CDE2)",
                  display: "inline-block",
                }}
              >
                {t("Pricing")}
              </span>
            </div>
          </motion.div>
        </div>
        <motion.h2
          className="text-[32px] mx-auto max-w-7xl px-4 xl:px-0 text-center md:text-[56px] leading-tight font-bold pt-5 pb-2"
          {...landingMotionInView}
        >
          {t("Choose Your")} <span className="italic text-gradient font-light px-1 ">{t("Account")}</span>
        </motion.h2>
        <motion.p
          className="text-base  text-white text-center md:text-xl max-w-[590px] mx-auto font-normal pt-0 "
          {...landingMotionInView}
        >
          {t("Choose from flexible plans designed for traders at every level. Transparent pricing with no hidden fees—start trading with confidence today.")}
        </motion.p>


      </div>
      <PricingComparisionTable variant="funnel" />
      <FaqSection />
      <CommunityCard />
      <Footer />

    </div>
  );
}

